import React from 'react';
import { ReportRecapStats } from './ReportSummary';

interface StepThanksProps {
  worshipAverage: number;
  baptisms: number;
  budgetTotal: number;
  missionTotal: number;
  onDone: () => void;
}

export const StepThanks: React.FC<StepThanksProps> = ({
  worshipAverage,
  baptisms,
  budgetTotal,
  missionTotal,
  onDone,
}) => (
  <div className="flex-1 flex flex-col items-center justify-center px-6 py-8 text-center space-y-6 bg-gradient-to-b from-primary-50/40 to-white animate-fade-in">
    <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center">
      <svg className="w-8 h-8 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <div>
      <h2 className="text-xl font-bold text-gray-900">Thank you for sharing</h2>
      <p className="text-gray-600 mt-2 max-w-sm leading-relaxed">
        Your leaders see your story and prayer first — we&apos;re grateful for your faithfulness this month.
      </p>
    </div>

    <ReportRecapStats
      worshipAverage={worshipAverage}
      baptisms={baptisms}
      budgetTotal={budgetTotal}
      missionTotal={missionTotal}
    />

    <button
      type="button"
      onClick={onDone}
      className="mt-2 px-8 py-3 rounded-xl bg-primary-600 text-white text-sm font-semibold hover:bg-primary-700 min-h-touch"
    >
      Back to my reports
    </button>
  </div>
);
